import { useAppSelector } from '@frontend/common';
import { FeatureConstraintData, isFeatureConstraintData } from '@frontend/constraint/types';
import { formStore, updateField } from '@frontend/repository';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { FeatureConstraintDataInputProps } from './feature-constraint-data-input.component';

interface ViewProps {
    formValues: FeatureConstraintData;
}

const useFeatureConstraintDataInput = (props: FeatureConstraintDataInputProps): ViewProps => {
    const store = useAppSelector(useSelector, formStore);
    const formValues = store[props.formId]?.value['data'];

    useEffect(() => {
        if (!isFeatureConstraintData(store[props.formId]?.value['data'])) {
            props.dispatch(updateField({ formId: props.formId, key: 'data', value: { feature: null } }));
        }
    }, []);

    return {
        formValues
    };
};

export default useFeatureConstraintDataInput;
